import { connect } from 'react-redux';

import DocsPage from '../pages/docs/Docs';

export default connect()(DocsPage);
